import React from 'react';
import { Loader2, AlertTriangle, Inbox, RefreshCw } from 'lucide-react';
import { Button } from '../ui/button';

export const LoadingState = ({ label = 'Cargando…' }) => (
  <div className="flex items-center justify-center py-16 text-slate-500 gap-2" data-testid="state-loading">
    <Loader2 className="w-5 h-5 animate-spin" /> <span className="text-sm">{label}</span>
  </div>
);

export const EmptyState = ({ title = 'Sin datos', description, icon: Icon = Inbox }) => (
  <div className="flex flex-col items-center justify-center py-16 text-center px-6" data-testid="state-empty">
    <div className="w-12 h-12 rounded-xl bg-slate-100 text-slate-500 flex items-center justify-center mb-4">
      <Icon className="w-6 h-6" />
    </div>
    <p className="text-slate-900 font-semibold">{title}</p>
    {description && <p className="text-slate-500 text-sm mt-1 max-w-md">{description}</p>}
  </div>
);

export const ErrorState = ({ description = 'No hemos podido cargar la información. Vuelve a intentarlo.', onRetry }) => (
  <div className="flex flex-col items-center justify-center py-16 text-center px-6" data-testid="state-error">
    <div className="w-12 h-12 rounded-xl bg-amber-50 text-amber-600 flex items-center justify-center mb-4">
      <AlertTriangle className="w-6 h-6" />
    </div>
    <p className="text-slate-900 font-semibold">Ha ocurrido un problema</p>
    <p className="text-slate-500 text-sm mt-1 max-w-md">{description}</p>
    {onRetry && (
      <Button
        onClick={onRetry}
        data-testid="state-error-retry"
        className="mt-5 bg-slate-900 hover:bg-slate-800 text-white gap-2"
      >
        <RefreshCw className="w-4 h-4" /> Reintentar
      </Button>
    )}
  </div>
);

export const Card = ({ children, className = '' }) => (
  <div className={`bg-white border border-slate-200 rounded-2xl ${className}`}>{children}</div>
);
